import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_membership_points_currency_hdr_RowClass} from '../../../dbschema/bl_crm_membership_points_currency_hdr.model';

export class MembershipPointsCurrencyContainerModel extends BaseContainerModel {
  bl_crm_membership_points_currency: bl_crm_membership_points_currency_hdr_RowClass = new bl_crm_membership_points_currency_hdr_RowClass();
  
}
